export default __webpack_public_path__ + "static/van-illustration-b06bd8100c40fd7ec3dc1d7ad06fc398.png";